<script>
    import {onMount} from "svelte"
    import {getPercentage, getState} from '../utils'

    export let silo;
    let messages = silo.messages;
    let nbrMessages = 500;

    let lineChart;
    let myChart;

    let min = silo.infos.min_value;
    let max = silo.infos.max_value;

    let danger = silo.infos.thresholds.danger.value;
    let warning = silo.infos.thresholds.warning.value;

    let data = {
        categoryData: messages.map(message => echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', new Date(message.date))),
        valueData: messages.map(message => getPercentage(silo, parseFloat(message.value)) * 100)
    };

    let option = {
        grid: {
            x: 60,
            y: 50,
            x2: 100,
            y2: 60,
            containLabel: false
        },
        dataZoom: [{
            type: 'inside'
        }, {
            type: 'slider'
        }],
        xAxis: {
            name: 'Time',
            nameTextStyle: {
                fontSize: 14
            },
            type: 'category',
            data: data.categoryData,
            axisLabel: {
                show: false
            },
        },
        yAxis: {
            name: '%',
            nameLocation: 'middle',
            nameGap: 30,
            nameTextStyle: {
                fontSize: 14
            },
            min: 0,
            max: 100
        },
        visualMap: {
            dimension: 1,
            top: 0,
            left: 'center',
            orient: 'horizontal',
            textStyle: {
                fontSize: 14,
                fontFamily: 'Poppins,sans-serif'
            },
            pieces: [{
                gt: 0,
                lte: danger,
                color: '#c44640',
                label: "Low-Low",
                symbol: "circle"
            },
                {
                    gt: danger,
                    lte: warning,
                    color: '#d8b62c',
                    label: "Low",
                    symbol: "circle"
                },
                {
                    gt: warning,
                    color: '#85c142',
                    label: "Normal",
                    symbol: "circle"
                }
            ]
        },
        series: [
            {
                type: 'bar',
                data: data.valueData,
                encode: {
                    // Map the "amount" column to X axis.
                    x: 'time',
                    // Map the "product" column to Y axis
                    y: 'feet'
                },
                markLine: {
                    silent: true,
                    data: [{
                        yAxis: danger,
                        lineStyle: {
                            color: '#c44640'
                        },
                        symbol: "none"
                    },
                        {
                            yAxis: warning,
                            lineStyle: {
                                color: '#d8b62c'
                            },
                            symbol: "none"
                        },
                        {
                            type: 'average',
                            name: 'Average',
                            lineStyle: {
                                color: '#007bff'
                            },
                            label: {
                                position: 'end',
                                formatter: "Average"
                            },
                            symbol: "none"
                        },

                    ]
                }
            }
        ]
    };

    onMount(() => {
        if (danger) {
            myChart = echarts.init(lineChart);
            myChart.setOption(option, true);
        }
    });

    function resize() {
        if (myChart)
            myChart.resize();
    }
</script>

<svelte:window on:resize={resize}/>

{#if silo !== undefined && silo.infos.thresholds.danger.value}
    <div class="card">
        <div class="card-body">
            <div class="card-head">
                <h2 class="card-title">Level History</h2>
                <div bind:this={lineChart} style="width:100%; height:300px;"></div>
            </div>
        </div>
    </div>
{/if}